<template>
   <div id="externalLinkManagement">
      <Loading v-if="loading"/>
      <div class="container-fluid">
         <div class="row justify-content-between align-items-center">
            <div class="col-auto back-button">
               <i class="fal fa-chevron-left step-button p-2" @click="backDashboad"></i>
            </div>
            <div class="position-fixed col-auto btn-save-container mb-3">
               <b-button class="btn-primario" @click="savePage">Salvar</b-button>
            </div>
         </div>
      </div>
      <div class="container pt-3">
         <div class="row text-left">
            <div class="col-12">
               <h3>Editar página</h3>
            </div>
            <div class="col-12 form-group">
               <label for="pageName">Nome</label>
               <input
                  type="text"
                  id="pageName"
                  class="form-control"
                  v-model="totalPage.title"
               >
            </div>
            <div class="col-12 col-lg-9 form-group">
               <label for="pageLink">Link (URL)</label>
               <input
                  type="text"
                  class="form-control"
                  placeholder="Ex: https://www.google.com"
                  v-model="totalPage.route"
               >
            </div>
            <div class="col-12 col-lg-3 form-group">
               <label for="openType">Abrir em:</label>
               <select name="" id="" class="form-control" v-model="totalPage.target_blank">
                  <option value="0">Mesma aba</option>
                  <option value="1">Nova aba</option>
               </select>
            </div>
            <div class="col-12 error-list" v-if="errorList.length > 0 || saveError">
               <span v-if="saveError">Erro ao atualizar a página.</span>
               <ul>
                  <li v-for="item in errorList" :key="item">
                     {{item}}
                  </li>
               </ul>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from 'axios';
import Loading from '@/components/Loading.vue';
export default {
   name: 'externalLinkManagement',
   data(){
      return{
         loading: false,
         totalPage: {},
         ROOT_API: '',
         errorList: [],
         saveError: false
      }
   },
   components:{
      Loading
   },
   created(){
      this.ROOT_API = process.env.ROOT_API;
   },
   mounted(){
      this.getPageData();
   },
   methods:{
      backDashboad(){
         window.localStorage.removeItem('pageId');
         this.$router.push('/dashboard');
      },
      getPageData(){
         this.loading = true;
         let pageId = this.$session.get('pageId'),
             siteId = this.$session.get('siteId');
         let token = this.$session.get('jwt');
         axios({
            method: 'get',
            url: this.ROOT_API+'/api/site/'+siteId+'/post/'+pageId,
            data: '',
            headers: {
               'Authorization': 'Bearer '+token,
               // 'Content-Type': 'application/x-www-form-urlencoded'
            }
         })
         .then(response => {
            console.log(response);
            this.totalPage = response.data.content;
            this.loading = false;
         })
         .catch(error => {
            console.log('Erro retornar post', error)
         })
      },
      savePage(){
         this.errorList = [];
         this.saveError = false;
         if(!this.totalPage.title){
            this.errorList.push('Nome obrigatório');
         }if(!this.totalPage.route){
            this.errorList.push('O link não pode estar vazio');
         }else{
            if(this.totalPage.route.substring(0, 7) != 'http://' && this.totalPage.route.substring(0, 8) != 'https://'){
               this.totalPage.route = `http://${this.totalPage.route}`
            }
         }
         if(this.errorList.length == 0){
            let   pageId = this.$session.get('pageId'),
                  siteId = this.$session.get('siteId'),
                  token = this.$session.get('jwt');
            axios({
               method: 'post',
               url: `${this.ROOT_API}/api/site/${siteId}/post/${pageId}/external/update`,
               data: this.totalPage,
               headers: {
                  'Authorization': 'Bearer '+token,
                  // 'Content-Type': 'application/x-www-form-urlencoded'
               }
            })
            .then(response => {
               this.backDashboad()
            })
            .catch(error => {
               this.saveError = true;
            })
         }
      }
   }
}
</script>

<style scoped>
    .btn-save-container {
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }
    .btn-save-container .btn-primario {
        padding: 0.5em 1em;
    }
   .back-button, .save-butom span{
      color: var(--main-color);
      cursor: pointer;
   }
   label{
      font-size: 0.8rem;
      margin-bottom: 0;
      color: #333333
   }
   .error-list{
      color: #d61a1a;
   }
   .error-list ul{
      padding: 0 15px;
   }
   .error-list ul li{
      font-size: 0.8rem;
   }
</style>



// WEBPACK FOOTER //
// src/components/organisms/ExternalLinkManagement.vue